/**
 * This file was auto-generated by Fern from our API Definition.
 */
export const FlatfileEnvironment = {
    Production: "https://api.x.flatfile.com/v1",
};
